import { faImages as faImagesLight } from '@fortawesome/pro-light-svg-icons';
import { faGears, faImages } from '@fortawesome/pro-regular-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { Helmet } from 'react-helmet-async';
import { useTranslation } from 'react-i18next';

import { AssetsSettingsForm } from '~/components/forms/AssetsSettingsForm';
import { Breadcrumbs } from '~/components/molecules/Breadcrumbs';
import { Heading } from '~/components/molecules/Heading';
import { AppBreadcrumbs } from '~/components/organisms/Breadcrumbs';

export type IAppAssetsSettingsPageProps = {
  appId: string;
};

export const AppAssetsSettingsPage: React.FC<IAppAssetsSettingsPageProps> = (
  props,
) => {
  const { appId } = props;
  const { t } = useTranslation();
  const parentUrl = `/apps/${appId}/settings`;

  return (
    <>
      <Helmet>
        <title>{t('AppAssetsSettingsPage.seo.title')}</title>
      </Helmet>

      <AppBreadcrumbs appId={appId}>
        <Breadcrumbs.Action href={parentUrl}>
          <FontAwesomeIcon icon={faGears} />
          {t('common.settings')}
        </Breadcrumbs.Action>
        <Breadcrumbs.Text current>
          <FontAwesomeIcon icon={faImages} />
          {t('AppAssetsSettingsPage.title')}
        </Breadcrumbs.Text>
      </AppBreadcrumbs>

      <Heading
        icon={<FontAwesomeIcon icon={faImagesLight} />}
        title={t('AppAssetsSettingsPage.title')}
        subtitle={t('AppAssetsSettingsPage.subtitle')}
        previousUrl={parentUrl}
      />
      <AssetsSettingsForm appId={appId} />
    </>
  );
};
